<template>
  <v-dialog eager @input="change" value="true" persistent max-width="600px">
    <v-card tile>
      <v-card-title class="pa-4">
        <h2>{{ title }}</h2>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-4 pt-4">
        <p v-html="message"></p>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          tile
          elevation="0"
          class="button background-color--inactive color--foreground"
          @click="choose(false)"
          >{{ dismissBtnText }}</v-btn
        >

        <v-btn
          tile
          elevation="0"
          class="button"
          color="primary"
          @click="choose(true)"
          >{{ confirmBtnText }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VDialog } from 'vuetify/lib'

export default {
  components: {
    VDialog,
  },
  props: {
    confirmBtnText: {
      type: String,
      default: 'Delete',
    },
    dismissBtnText: {
      type: String,
      default: 'Cancel',
    },
    title: {
      type: String,
      default: 'Please confirm',
    },
    message: {
      type: String,
      default: 'Are you sure?',
    },
  },
  data: () => ({
    value: false,
  }),
  methods: {
    choose(value) {
      this.$emit('result', value)
      this.value = value
      this.$destroy()
    },
    change() {
      this.$destroy()
    },
  },
}
</script>
